// lib/components/sortable/sortable/sortable.tsx
import {
  DndContext,
  KeyboardSensor,
  PointerSensor,
  closestCenter,
  useSensor,
  useSensors
} from "@dnd-kit/core";
import {
  restrictToParentElement,
  restrictToVerticalAxis,
  restrictToWindowEdges
} from "@dnd-kit/modifiers";
import {
  SortableContext,
  arrayMove,
  useSortable,
  verticalListSortingStrategy
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { jsx } from "@emotion/react/jsx-runtime";
var Sortable = ({
  items,
  SortableItem,
  getIdentity,
  getDisabled,
  onSort,
  modifiers = [restrictToVerticalAxis, restrictToParentElement],
  strategy = verticalListSortingStrategy
}) => {
  const pointerSensor = useSensor(PointerSensor, {
    activationConstraint: {
      delay: 0,
      tolerance: 1e3
    }
  });
  const keyboardSensor = useSensor(KeyboardSensor, {});
  const sensors = useSensors(pointerSensor, keyboardSensor);
  const options = items.map((item) => ({ id: getIdentity(item) }));
  return /* @__PURE__ */ jsx(
    DndContext,
    {
      onDragEnd: ({ active, over }) => {
        if (over && active.id !== over.id) {
          const oldIndex = items.findIndex(
            (item) => getIdentity(item) === active.id
          );
          const newIndex = items.findIndex(
            (item) => getIdentity(item) === over.id
          );
          onSort(arrayMove(items, oldIndex, newIndex));
        }
      },
      autoScroll: {
        canScroll: (e) => e.tagName !== "HTML"
      },
      accessibility: {
        container: document.getElementById("__next") ?? void 0
      },
      modifiers: [...modifiers, restrictToWindowEdges],
      collisionDetection: closestCenter,
      sensors,
      children: /* @__PURE__ */ jsx(SortableContext, { items: options, strategy, children: items.map((item) => {
        const itemId = getIdentity(item);
        const disabled = getDisabled?.(item) ?? false;
        return /* @__PURE__ */ jsx(
          SortableItemComponent,
          {
            itemId,
            item,
            disabled,
            SortableItem
          },
          itemId
        );
      }) })
    }
  );
};
var SortableItemComponent = ({
  itemId,
  item,
  disabled,
  SortableItem
}) => {
  const {
    isDragging,
    listeners,
    attributes,
    transform,
    transition,
    setNodeRef,
    setActivatorNodeRef
  } = useSortable({
    id: itemId,
    disabled
  });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };
  return /* @__PURE__ */ jsx(
    SortableItem,
    {
      item,
      style,
      grabbing: isDragging,
      attributes,
      listeners,
      setNodeRef,
      setActivatorNodeRef
    }
  );
};

export {
  Sortable
};
